module.exports = __webpack_public_path__ + "static/Chat_esp_desk-a4c896fce7f0c2cc2163f56459a3a0e4.mp4";